
<ng-container *ngIf="subscription$|async as sub">
  <h1>Abo # {{sub.id}}</h1>
<ng-container *ngIf="orders$|async as orders">
<cw-base-order-list [orders]="orders"></cw-base-order-list>
</ng-container>
</ng-container>
